import { AfterContentChecked, Component, Input } from "@angular/core"
import { CollectionNode } from "../../../../models/collectionNode.model"
import { GlobalStoreService } from "../../../../services/global-store.service"
import { STATIC_IMAGES } from "../../../../models/constants"

@Component({
    selector: "app-collection-box",
    templateUrl: "./collection-box.component.html",
    styleUrls: ["./collection-box.component.scss"],
    standalone: false,
})
export class CollectionBoxComponent implements AfterContentChecked {
    @Input() collection: CollectionNode
    posterImage1: string = null
    posterImage2: string = null
    posterImage3: string = null
    placeholderImage: string = null

    constructor(private globalStoreService: GlobalStoreService) {
        this.placeholderImage = STATIC_IMAGES.default_subcollection_banner
    }

    prepareImage(imageURL) {
        if (!imageURL) {
            return this.placeholderImage
        }
        return `${imageURL}?resize=180x110&format=${this.globalStoreService.imageFormat}`
    }

    ngAfterContentChecked() {
        this.posterImage1 = this.prepareImage(this.collection.poster_images[2])
        this.posterImage2 = this.prepareImage(this.collection.poster_images[1])
        this.posterImage3 = this.prepareImage(this.collection.poster_images[0])
    }
}
